import { render, staticRenderFns } from "./AppTimelineItem.vue?vue&type=template&id=4bbac430&scoped=true"
import script from "./AppTimelineItem.vue?vue&type=script&lang=js"
export * from "./AppTimelineItem.vue?vue&type=script&lang=js"
import style0 from "./AppTimelineItem.vue?vue&type=style&index=0&id=4bbac430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbac430",
  null
  
)

export default component.exports